import { render, staticRenderFns } from "./LightBoxInsert.vue?vue&type=template&id=54b54f2a&"
import script from "./LightBoxInsert?vue&type=script&lang=ts&"
export * from "./LightBoxInsert?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports